import React from 'react';

import './style.scss';

const ImageCardGallery = ({ columns = 2, children }) => {
	return <div className={`image-card-gallery gallery-columns-${columns}`}>{children}</div>;
};

export default ImageCardGallery;
